import { useLocalStorage } from '@vueuse/core'
import type CreatableFeedback from '../../modules/give-feedback/models/creatable-feedback'

export const useLocalFeedbacks = () => {
  const feedbacksByPublicToken = (token: string) => {
    const localStorageKey = `feedbacks-${token}`
    return useLocalStorage<Omit<CreatableFeedback, 'feedbackReceiverId'>[]>(localStorageKey, [])
  }

  const feedbacksBySurveyIdAndReceiverId = (surveyId: string, receiverId: string) => {
    const localStorageKey = `feedbacks-${surveyId}-${receiverId}`
    return useLocalStorage<CreatableFeedback[]>(localStorageKey, [])
  }

  const feedbacksBySurveyId = (surveyId: string) => {
    const localStorageKey = `feedbacks-${surveyId}`
    const feedbacks = useLocalStorage<CreatableFeedback[]>(localStorageKey, [])
    return feedbacks
  }

  const feedbacksByPublicTokenAndReceiverId = (token: string, receiverId: string) => {
    const localStorageKey = 'feedbacks-' + token + '-' + receiverId
    const feedbacks = useLocalStorage<CreatableFeedback[]>(localStorageKey, [])
    return feedbacks
  }

  return {
    feedbacksByPublicTokenAndReceiverId,
    feedbacksBySurveyIdAndReceiverId,
    feedbacksBySurveyId,
    feedbacksByPublicToken,
  }
}
